import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=3ccd81e0&scoped=true"
import script from "./explain.vue?vue&type=script&lang=js"
export * from "./explain.vue?vue&type=script&lang=js"
import style0 from "./explain.vue?vue&type=style&index=0&id=3ccd81e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccd81e0",
  null
  
)

export default component.exports